<script>
  import { faEdit, faEye, faFile } from "@fortawesome/free-solid-svg-icons"
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import ActionsDropdown from "@/core/components/ActionsDropdown"
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"
  import RegularLineCertificate from "@/domains/lines/views/regularLines/components/RegularLineCertificate.vue"
  import RegularLineDetail from "@/domains/lines/views/regularLines/components/RegularLineDetail"
  import Cancel from "@/domains/spl-navegantes/partials/icons/Cancel.vue"
  import Check from "@/domains/spl-navegantes/partials/icons/Check.vue"

  export default {
    components: {
      RegularLineCertificate,
      RegularLineDetail,
      ActionsDropdown,
      ResponsiveTable,
      FontAwesomeIcon,
      Check,
      Cancel,
    },
    props: {
      origin: {
        type: Object,
        default: () => ({
          id: 0,
          name: "Origem",
        }),
      },
      search: {
        type: String,
        default: "",
      },
      filters: {
        type: Object,
        default: () => ({
          transportadora: 0,
          linha: 0,
          origem: {
            id: 0,
            name: "Origem",
          },
          destino: {
            id: 0,
            name: "Destino",
          },
        }),
      },
    },
    data() {
      return {
        faEye,
        faEdit,
        faFile,
        status: "pending",
        loading: false,
        headers: [
          "Linha",
          "Transportadora",
          "Origem",
          "Destino",
          // "Horários",
          "Serviço",
          "Situação",
          "Ações",
        ],
        page: 1,
        pagination: {},
        visible: false,
        visibleCertificate: false,
        sessions: [],
        session: {},
        canEdit: false,
      }
    },
    watch: {
      origin() {
        this.page = 1
        this.getLines()
      },
    },
    mounted() {
      if (this.$route.query.sectionPoint) {
        this.getLinesOfSectionPoint(this.$route.query.sectionPoint)
      } else {
        this.getLines()
      }
      if (this.$store.state.auth.link.organization.id === 0) {
        this.canEdit = true
      }
    },
    methods: {
      getLinesOfSectionPoint(id) {
        this.status = "pending"
        this.$Progress.start()
        this.loading = true
        this.$axios
          .post(
            `/api/lines/route/search/section-point/${id}` + "?page=" + this.page
          )
          .then((resp) => {
            this.sessions = resp.data.data
            this.pagination = resp.data
            delete this.pagination.data
            this.loading = false
            this.status = "finished"
            this.$Progress.finish()
          })
          .catch(() => {
            this.sessions = []
            this.loading = false
            this.status = "rejected"
            this.$Progress.finish()
          })
      },
      getLines() {
        this.status = "pending"
        this.$Progress.start()
        this.loading = true
        this.$axios
          .post("/api/lines/route/search?page=" + this.page, {
            search: this.search,
            filters: this.filters,
            origin: this.origin,
            orderBy: {
              idlinha: "DESC",
            },
          })
          .then((resp) => {
            this.sessions = resp.data.data
            this.pagination = resp.data
            delete this.pagination.data
            this.loading = false
            this.status = "finished"
            this.$Progress.finish()
          })
          .catch(() => {
            this.sessions = []
            this.loading = false
            this.status = "rejected"
            this.$Progress.finish()
          })
      },
      changePage(page) {
        if (page !== this.page && this.status !== "pending") {
          this.page = page
          if (this.$route.query.sectionPoint) {
            this.getLinesOfSectionPoint(this.$route.query.sectionPoint)
          } else {
            this.getLines()
          }
        }
      },
      editSession(session) {
        this.$router.push({
          name: "lines.regular.edit",
          params: {
            id: session.id,
          },
        })
        return session
      },
      viewRegularLine(session) {
        this.session = session
        this.visible = true
      },
      closeRegularLine() {
        this.visible = false
      },
      viewCertificate(session) {
        this.session = session
        this.visibleCertificate = true
      },
      closeCertificate() {
        this.visibleCertificate = false
      },
      dataList(data) {
        if (data.length > 0) {
          return data.map((item) => ({
            id: item.idlinha,
            linha: item.nulinharamal + "-" + item.nuextensao,
            name: item.deter_registry?.organization?.business_name || "--",
            tpoperacao: () =>
              item.tpoperacao == "1" ? "Rodoviário" : "Urbano",
            initialPoint: () =>
              item.origin_point
                ? item.origin_point.nmlocalidade +
                  " (" +
                  item.origin_point.city.nmmunicipio +
                  ")"
                : "--",
            finalPoint: () =>
              item.destiny_point
                ? item.destiny_point.nmlocalidade +
                  " (" +
                  item.destiny_point.city.nmmunicipio +
                  ")"
                : "--",
            flsituacao: item.flsituacao,
          }))
        }
        return []
      },
      getColorBySituation(situation) {
        if (situation == 1) {
          return "#00A86B"
        }
        return "#FF0000"
      },
    },
  }
</script>

<template>
  <div>
    <ResponsiveTable
      :headers="headers"
      :data="dataList(sessions)"
      :pagination="pagination"
      :disabled="loading"
      :status="status"
      :has-pagination="true"
      @changePage="
                page => {
                    changePage(page);
                }
            "
    >
      <template #row="props">
        <td :class="props.tdClass" class="text-xs p-3">
          {{ props.row.linha }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3">{{ props.row.name }}</td>
        <td :class="props.tdClass" class="text-xs p-3">
          {{ props.row.initialPoint() }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3">
          {{ props.row.finalPoint() }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3">
          {{ props.row.tpoperacao() }}
        </td>
        <!-- <td :class="props.tdClass" class="list-hours text-xs p-3">
                    <span
                        v-for="hour in props.row.hours"
                        v-bind:key="hour.idhorario"
                    >
                        {{ hour.hrpartida }};
                    </span>
                </td> -->
        <td
          :class="props.tdClass"
          :style="
                        `color: ${getColorBySituation(props.row.flsituacao)}`
                    "
          class="flex items-center h-full gap-2"
        >
          <div class="h-max">
            <Check v-if="props.row.flsituacao == 1"/>
            <Cancel v-if="props.row.flsituacao == 2"/>
          </div>
          {{ props.row.flsituacao == 1 ? "ATIVO" : "INATIVO" }}
        </td>

        <td :class="props.tdClass">
          <div class="flex items-baseline">
            <div
              v-if="props.row.flsituacao == 1"
              class="text-green-base cursor-pointer mr-2"
              title="Gerar certificado"
              @click="viewCertificate(props.row)"
            >
              <svg
                class="w-3 h-3"
                fill="currentColor"
                viewBox="0 4 56 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M50.2425 11.0073L39.7425 0.507284C39.4123 0.179706 38.9652 -0.00284122 38.5 -0.000216217H10.5C7.60047 -0.000216217 5.25 2.35025 5.25 5.24978V50.7498C5.25 53.6493 7.60047 55.9998 10.5 55.9998H45.5C48.3995 55.9998 50.75 53.6493 50.75 50.7498V12.2498C50.7527 11.7846 50.5701 11.3376 50.2425 11.0073ZM47.25 50.7498C47.25 51.7163 46.4665 52.4998 45.5 52.4998H10.5C9.53345 52.4998 8.75 51.7163 8.75 50.7498V5.24978C8.75 4.28324 9.53345 3.49978 10.5 3.49978H36.75V10.4998C36.75 12.4328 38.317 13.9998 40.25 13.9998H47.25V50.7498Z"
                  />
                  <path d="M43.75 42H40.25V45.5H43.75V42Z"/>
                  <path d="M43.75 24.5H12.25V28H43.75V24.5Z"/>
                  <path d="M43.75 33.25H12.25V36.75H43.75V33.25Z"/>
                  <path d="M36.75 42H12.25V45.5H36.75V42Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="56" height="56" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              class="text-green-base cursor-pointer mr-2"
              title="Visualizar horários"
              @click="viewRegularLine(props.row)"
            >
              <FontAwesomeIcon :icon="faEye"></FontAwesomeIcon>
            </div>
            <div
              v-if="canEdit"
              class="text-green-base cursor-pointer"
              title="Editar Sessão"
              @click="editSession(props.row)"
            >
              <FontAwesomeIcon :icon="faEdit"></FontAwesomeIcon>
            </div>
          </div>
        </td>
      </template>
      <template #responsive="props">
        <tr>
          <th :class="props.thClass">linha</th>
          <td :class="props.tdClass + ' relative'">
            <ActionsDropdown class="absolute right-0 top-0">
              <template slot="actions">
                <div
                  v-if="props.row.flsituacao == 1"
                  class="block hover:text-white text-gray-800 px-4 py-2 hover:bg-green-500 w-full text-left"
                  title="Gerar Certificado"
                  @click="viewCertificate(props.row)"
                >
                  Gerar certificado
                </div>
                <div
                  class="block hover:text-white text-gray-800 px-4 py-2 hover:bg-green-500 w-full text-left"
                  title="Visualizar horários"
                  @click="viewRegularLine(props.row)"
                >
                  Visualizar horários
                </div>
                <div
                  v-if="canEdit"
                  class="block hover:text-white text-gray-800 px-4 py-2 hover:bg-green-500 w-full text-left"
                  title="Editar Sessão"
                  @click="editSession(props.row)"
                >
                  Editar Sessão
                </div>
              </template>
            </ActionsDropdown>
            {{ props.row.id }}
          </td>
        </tr>
        <tr>
          <th :class="props.thClass">Transportadora</th>
          <td :class="props.tdClass">{{ props.row.name }}</td>
        </tr>
        <tr>
          <th :class="props.thClass">Origem</th>
          <td :class="props.tdClass">{{ props.row.initialPoint() }}</td>
        </tr>
        <tr>
          <th :class="props.thClass">Destino</th>
          <td :class="props.tdClass">{{ props.row.finalPoint() }}</td>
        </tr>
        <tr>
          <th :class="props.thClass">Serviço</th>
          <td :class="props.tdClass">{{ props.row.tpoperacao() }}</td>
        </tr>
        <tr>
          <th :class="props.thClass">Situação</th>
          <td
            :class="props.tdClass"
            :style="
                            `color: ${getColorBySituation(
                                props.row.flsituacao
                            )}`
                        "
            class="flex items-center h-full gap-2"
          >
            <div class="h-max">
              <Check v-if="props.row.flsituacao == 1"/>
              <Cancel v-if="props.row.flsituacao == 2"/>
            </div>
            {{ props.row.flsituacao == 1 ? "ATIVO" : "INATIVO" }}
          </td>
        </tr>
      </template>
    </ResponsiveTable>
    <RegularLineDetail
      v-if="visible"
      :id-linha="session.id"
      @close="visible = false"
    />
    <RegularLineCertificate
      v-if="visibleCertificate"
      :id-linha="session.linha"
      @close="visibleCertificate = false"
    />
  </div>
</template>
